module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-verwijzend-voornaamwoord.json
// module id = 1309
// module chunks = 4997816555802